import { Component, OnInit } from '@angular/core';
import { FcmMessageService } from './services/fcm-message/fcm-message.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // Firebase setup
  private message;

  constructor(private fcmmessagingService: FcmMessageService) {}

  ngOnInit() {
    this.fcmmessagingService.requestPermission();
    this.fcmmessagingService.receiveMessage();
    this.message = this.fcmmessagingService.currentMessage;
  }
}
